import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleFree: {
		id: 'language-settings.edit-disabled-banner.title-free',
		defaultMessage: "Templates can't be edited on a Free plan",
		description: 'Title for templates edit disabled for free plan',
	},
	messageFree: {
		id: 'language-settings.edit-disabled-banner.message-free',
		defaultMessage:
			"You can edit notification templates after you've upgraded your plan and completed the evaluation period. If you need to enable the feature during your evaluation period, contact Atlassian support.",
		description: 'Message about editing templates is disabled for the free plan',
	},
	ctaFree: {
		id: 'language-settings.edit-disabled-banner.cta-free',
		defaultMessage: 'Upgrade your plan',
		description: 'Cta to upgrade plan',
	},
	titleEvaluating: {
		id: 'language-settings.edit-disabled-banner.title-evaluating',
		defaultMessage: 'Template editing is restricted',
		description: 'Title for notification templates edit disabled for evaluating tenant',
	},
	messageEvaluating: {
		id: 'language-settings.edit-disabled-banner.message-evaluating',
		defaultMessage:
			'You can edit notification templates after your evaluation period ends. If you need to enable the feature during your evaluation period, <link>contact Atlassian support</link>.',
		description: 'Message about notification templates edititing is disabled for evaluating tenant',
	},
});
